import type { SpinResponse } from "@slot/client-engine";
import { fx, spinFixture } from "@slot/game-shell";

/**
 * Reels — server-flagged ANTICIPATION (Stage 1 motion gate). Scatters (FS) land on reels 1
 * + 3 (1-based); reels 4 + 5 are flagged to anticipate, so each slows + spins an extra beat
 * before stopping on a non-scatter — a sequential near-miss tease.
 *
 * Exercises: reels 1–3 land normally; then reel 4 ramps v→antV, holds the slow beat, reveals
 * + brakes, lands; THEN reel 5 does the same (sequential — the cursor holds one reel at a
 * time). Turbo shortens each beat; a slam mid-beat fast-finishes. No win.
 *
 * 5 reels × 4 rows; catalog symbols (H1–H4 / L1–L5 / FS). `anticipate([3, 4])` (0-based) sets
 * eventContent.anticipatedColumns → ReelGridPresenter → ReelSpinMechanic → `ReelDrum` (the slow
 * beat) + `ReelAnticipation` (the frame).
 */
export function baseFixtureReelAnticipation(): SpinResponse {
  return spinFixture("reel-anticipation")
    .balance("EUR", "100000")
    .event("reveal", 0, (e) => {
      // FS on col index 0 (reel 1) + col index 2 (reel 3); no 3-in-a-row (presentation-only).
      // anticipate([3, 4]) = reels 4 and 5 (indices 3, 4) tease, one after the other.
      e.reelSet("default").accumulatedWinAfter("0")
        .gridRows([
          ["FS", "L4", "L1", "L2", "L3"],
          ["L3", "L2", "L4", "L1", "L5"],
          ["L1", "L2", "FS", "L3", "L5"],
          ["L2", "L3", "L5", "L4", "L1"],
        ])
        .anticipate([3,4]);

      const s = fx.spinBoundaryStart("base:1", "base");
      e.action(s.type, s.payload, { actionPhaseName: s.phase, debugTag: "start" });

      const end = fx.spinBoundaryEnd("base:1", "0");
      e.action(end.type, end.payload, { actionPhaseName: end.phase, debugTag: "end" });
    })
    .build();
}
